import React, { createContext, useContext, useState, useEffect } from 'react';
import { getAraAppState, setAraAppState } from '../utils/ara-storage';

/*
 * ThemeContext — scoped to Ara. Toggles between 'light' and 'dark'.
 * Preference saved locally in AraSanctuaryDB app_state. Applies a
 * data-ara-theme attribute on the Ara root element; CSS variables in
 * index.css respond to this attribute. Vela's styling is untouched.
 */

const ThemeContext = createContext(null);

export const useAraTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useAraTheme must be used within AraThemeProvider');
  return ctx;
};

export const AraThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState('light');

  useEffect(() => {
    (async () => {
      try {
        const saved = await getAraAppState('ara_theme');
        if (saved === 'dark' || saved === 'light') setThemeState(saved);
      } catch (e) {
        // default remains 'light'
      }
    })();
  }, []);

  const setTheme = async (next) => {
    setThemeState(next);
    try {
      await setAraAppState('ara_theme', next);
    } catch (e) {
      // non-fatal — in-memory setting still applied
    }
  };

  const toggleTheme = () => setTheme(theme === 'dark' ? 'light' : 'dark');

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
